<template>
 <div class="myworks__header">
  <h1 class="myworks__header-h1">My works</h1>
  <p class="myworks__header-p">Here you can find all my endeavours in the sphere of web development.</p>
 </div>
</template>

<script>
 export default {
  
 }
</script>

<style>
.myworks__header {
 padding: 50px 0 25px;
 text-align: center;
 color: #f2f2f2;
}
.myworks__header-h1 {
 color: #cea25f;
}
</style>